// goalBits.jsx — the small pieces every goals surface shares.
import React from 'react';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import LayersOutlinedIcon from '@mui/icons-material/LayersOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import { STATUS_LABEL, METRICS } from './goalModel';

const ICON_COMPONENTS = {
  book: MenuBookOutlinedIcon,
  image: ImageOutlinedIcon,
  bulb: LightbulbOutlinedIcon,
  pen: EditOutlinedIcon,
  layers: LayersOutlinedIcon,
  clock: ScheduleOutlinedIcon,
  flag: FlagOutlinedIcon,
};

export const iconFor = (goal) => goal.icon || METRICS[goal.metric]?.icon || 'flag';

/** The round (or, in the detail header, rounded-square) tinted goal icon. */
export function GoalIcon({ icon, size = 64, square = false }) {
  const Svg = ICON_COMPONENTS[icon];
  return (
    <span
      className={`gv-icon gv-icon--${icon || 'flag'}${square ? ' is-square' : ''}`}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.42) }}
      aria-hidden="true"
    >
      {Svg ? <Svg style={{ fontSize: 'inherit' }} /> : <span className="gv-icon-aa">Aa</span>}
    </span>
  );
}

/** The bare icon, no tinted circle — for inline use beside text. */
export function GoalGlyph({ icon }) {
  const Svg = ICON_COMPONENTS[icon];
  return Svg ? <Svg fontSize="small" /> : <span className="gv-icon-aa">Aa</span>;
}

export function StatusPill({ status, large = false }) {
  return <span className={`gv-pill gv-pill--${status}${large ? ' is-large' : ''}`}>{STATUS_LABEL[status]}</span>;
}

export function Priority({ value, onDark = false }) {
  const p = (value || 'MEDIUM').toUpperCase();
  return <span className={`gv-prio gv-prio--${p.toLowerCase()}${onDark ? ' on-dark' : ''}`}>{p}</span>;
}

const hashOf = (s) => [...String(s || '')].reduce((a, c) => (a * 31 + c.charCodeAt(0)) % 997, 7);

/** An initial in a circle, coloured by who it is. */
export function Avatar({ id, name, size = 24 }) {
  const label = (name || '?').trim();
  return (
    <span
      className={`gv-av gv-av--${hashOf(id || label) % 6}`}
      style={{ width: size, height: size, fontSize: Math.max(10, Math.round(size * 0.44)) }}
      title={label}
    >
      {label[0]?.toUpperCase() || '?'}
    </span>
  );
}

export function Bar({ pct, status, thin = false, className = '' }) {
  return (
    <div className={`gv-bar${thin ? ' is-thin' : ''} ${className}`}>
      <i className={`gv-bar-fill gv-bar-fill--${status}`} style={{ width: `${Math.max(0, Math.min(100, pct || 0))}%` }} />
    </div>
  );
}
